import { devices } from '@src/styles/theme';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styled from 'styled-components';

const LoadingBloodHomeSkeleton = () => {
  return (
    <Wrap>
      {/* <Skeleton style={{ width: '100%',height: '140px' }} /> */}
      <CustomSkeleton />
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 33%;
  padding: 30px 20px;
  @media ${devices.tablet} {
    width: 49%;
    padding: 15px 10px;
  }
`;

const CustomSkeleton = styled(Skeleton)`
  width: '100%';
  height: 140px;

  @media ${devices.tablet} {
    height: 80px;
  }
`;

export default LoadingBloodHomeSkeleton;
